
import { defineComponent, toRefs } from 'vue';
import { useStepper } from '@/components/wizard/stepper';

import Card from '@/components/Card.vue';
import Navigation from './Navigation.vue';

export default defineComponent({
  name: 'WizardStep',
  props: {
    step: Number,
    title: String,
    navigation: { type: Boolean, default: true },
  },
  components: {
    Card,
    Navigation,
  },
  setup(props) {
    const { step } = toRefs(props);
    const stepper = useStepper(step);

    return {
      ...stepper,
    };
  },
});
